/**
 * LEORI — commande à la livraison.
 *
 * Envoie le formulaire au serveur LEORI, qui crée la commande dans l'admin
 * Shopify. Le navigateur ne transmet jamais de prix : uniquement des
 * identifiants de variante et des quantités.
 *
 * Sans JavaScript, le formulaire ne s'affiche pas et le bouton d'ajout au
 * panier reste la sortie : mieux vaut un parcours plus long qu'un formulaire
 * qui ne part nulle part.
 */
(function () {
  'use strict';

  const argent = (centimes, format) => {
    const n = (centimes / 100).toLocaleString('fr-MA', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    return (format || '{{amount}} MAD').replace(/\{\{\s*amount[^}]*\}\}/, n);
  };

  document.querySelectorAll('[data-leori-cod]').forEach(function (racine) {
    const form = racine.querySelector('[data-cod-form]');
    if (!form) return;

    const endpoint = racine.dataset.codEndpoint;
    const contexte = racine.dataset.codContexte;
    const bouton = racine.querySelector('[data-cod-envoyer]');
    const libelle = racine.querySelector('[data-cod-libelle]');
    const boiteErreur = racine.querySelector('[data-cod-erreur]');
    const done = racine.querySelector('[data-cod-done]');

    /* ---------- Ce qu'on commande ---------- */

    /* Contexte produit : la variante suit les pastilles. Le thème pose un
       <select name="id"> caché à côté des radios d'options, sans rien qui les
       relie — une pastille cliquée ne changeait donc pas la variante. On les
       relie ici, ce qui redresse aussi le bouton d'ajout au panier. */
    const bloc = racine.closest('.leori-pdp__buy, .leori-pdp, .leori-cart, body');
    const selectVariante = bloc && bloc.querySelector('select[name="id"]');
    const donnees = document.getElementById('leori-variantes-' + (racine.dataset.codProduit || ''));
    const variantes = donnees ? JSON.parse(donnees.textContent) : null;
    const formatArgent = racine.dataset.codFormat || '{{amount}} MAD';

    const optionsChoisies = () => {
      if (!bloc) return [];
      return Array.from(bloc.querySelectorAll('.leori-pdp__radio:checked')).map((r) => r.value);
    };

    const varianteCourante = () => {
      if (variantes) {
        const choix = optionsChoisies();
        if (choix.length) {
          const trouve = variantes.find((v) => v.options.length === choix.length
            && v.options.every((o, i) => o === choix[i]));
          if (trouve) return trouve;
        }
        if (selectVariante) {
          const parId = variantes.find((v) => String(v.id) === selectVariante.value);
          if (parId) return parId;
        }
        return variantes[0];
      }
      return selectVariante ? { id: selectVariante.value, prix: null } : null;
    };

    const champQte = form.querySelector('[name="quantite"]');
    const totalEl = racine.querySelector('[data-cod-total]');
    const lignePrixEl = racine.querySelector('[data-cod-ligne-prix]');

    const rafraichir = () => {
      if (contexte !== 'produit') return;
      const v = varianteCourante();
      if (!v || v.prix == null) return;
      const q = Math.max(1, Math.min(10, parseInt(champQte && champQte.value, 10) || 1));
      if (lignePrixEl) lignePrixEl.textContent = argent(v.prix, formatArgent);
      if (totalEl) totalEl.textContent = argent(v.prix * q, formatArgent);
      /* On garde le <select> aligné : le bouton d'ajout au panier s'en sert. */
      if (selectVariante && String(selectVariante.value) !== String(v.id)) selectVariante.value = v.id;
    };

    if (contexte === 'produit') {
      if (bloc) bloc.addEventListener('change', (e) => {
        if (e.target.matches('.leori-pdp__radio, [name="quantite"]')) rafraichir();
      });
      rafraichir();
    }

    const lignes = () => {
      if (contexte === 'produit') {
        const v = varianteCourante();
        if (!v) return [];
        const q = Math.max(1, Math.min(10, parseInt(champQte && champQte.value, 10) || 1));
        return [{ id: String(v.id), quantite: q }];
      }
      return Array.from(racine.querySelectorAll('[data-cod-item]'))
        .map((el) => ({ id: el.dataset.variante, quantite: parseInt(el.dataset.quantite, 10) || 1 }));
    };

    /* ---------- Erreurs ---------- */

    const errs = {};
    racine.querySelectorAll('[data-cod-err]').forEach((el) => { errs[el.dataset.codErr] = el; });

    const effacer = () => {
      Object.values(errs).forEach((el) => { el.textContent = ''; });
      form.querySelectorAll('.is-fautif').forEach((el) => el.classList.remove('is-fautif'));
      if (boiteErreur) { boiteErreur.hidden = true; boiteErreur.textContent = ''; }
    };

    const poser = (map) => {
      let premier = null;
      Object.entries(map).forEach(([champ, message]) => {
        if (errs[champ]) errs[champ].textContent = message;
        const input = form.querySelector('[name="' + champ + '"]');
        if (input) {
          input.classList.add('is-fautif');
          input.setAttribute('aria-invalid', 'true');
          if (!premier) premier = input;
        }
      });
      if (premier) premier.focus();
    };

    const global = (message) => {
      if (!boiteErreur) return;
      boiteErreur.textContent = message;
      boiteErreur.hidden = false;
      boiteErreur.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    };

    /* Le même motif que le champ et que le serveur : trois endroits, une règle. */
    const TEL = /^(?:\+212|00212|0)[\s.\-]?[67](?:[\s.\-]?\d){8}$/;

    /* ---------- Envoi ---------- */

    let enCours = false;

    form.addEventListener('submit', async function (e) {
      e.preventDefault();
      if (enCours) return;
      effacer();

      const d = Object.fromEntries(new FormData(form).entries());
      const local = {};
      if (!d.nom || d.nom.trim().length < 3) local.nom = 'Indiquez votre prénom et votre nom.';
      if (!TEL.test((d.telephone || '').trim())) local.telephone = 'Numéro marocain : 06 12 34 56 78.';
      if (!d.ville || d.ville.trim().length < 2) local.ville = 'Indiquez votre ville.';
      if (!d.adresse || d.adresse.trim().length < 8) local.adresse = 'Rue, numéro, immeuble.';
      if (Object.keys(local).length) return poser(local);

      const paquet = {
        nom: d.nom, telephone: d.telephone, ville: d.ville,
        quartier: d.quartier || '', adresse: d.adresse,
        repere: d.repere || '', note: d.note || '',
        societe: d.societe || '',
        lignes: lignes()
      };
      if (!paquet.lignes.length) return global('Aucun article à commander.');

      enCours = true;
      bouton.disabled = true;
      const avant = libelle.textContent;
      libelle.textContent = 'Envoi…';

      try {
        const r = await fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(paquet)
        });
        const j = await r.json().catch(() => ({}));

        if (r.ok && j.ok) {
          form.hidden = true;
          if (done) {
            const num = done.querySelector('[data-cod-num]');
            if (num && j.commande) num.textContent = ' — ' + j.commande;
            done.hidden = false;
            done.setAttribute('tabindex', '-1');
            done.focus();
            done.scrollIntoView({ block: 'center', behavior: 'smooth' });
          }
          /* Le panier a servi : on le vide, sinon la cliente le retrouve
             plein et croit que rien n'est parti. */
          if (contexte === 'panier') {
            fetch('/cart/clear.js', { method: 'POST' }).catch(() => {});
          }
          return;
        }

        if (j.erreurs) return poser(j.erreurs);
        global(j.erreur || 'La commande n’a pas pu être enregistrée. Réessayez, ou écrivez-nous sur WhatsApp.');

      } catch (err) {
        global('Connexion perdue. Vérifiez votre réseau et réessayez, ou écrivez-nous sur WhatsApp.');
      } finally {
        enCours = false;
        bouton.disabled = false;
        libelle.textContent = avant;
      }
    });
  });
})();
